<template>
  <component :is="stepComponent" v-if="stepComponent && isStepVisible" :step="currentStep" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useLookModal } from '@/features/look/store'
import type { LookStep } from '@/features/look/types/look-config'

import WelcomeStep from './WelcomeStep.vue'
import OccasionStep from './OccasionStep.vue'
import DynamicFormStep from './DynamicFormStep.vue'
import TinderLikeStep from './TinderLikeStep.vue'
import CompletionStep from './CompletionStep.vue'

const lookStore = useLookModal()
const currentStep = computed(() => lookStore.currentStep)

const isStepVisible = computed(() => {
  const step = currentStep.value
  if (!step) return false
  
  return lookStore.shouldStepBeVisible(step)
})

const stepComponent = computed(() => {
  const step = currentStep.value
  if (!step) return null

  switch (step.type) {
    case 'welcome':
      return WelcomeStep
    case 'occasion':
      return OccasionStep
    case 'dynamic_form':
      return DynamicFormStep
    case 'tinder_like':
      return TinderLikeStep
    case 'completion':
      return CompletionStep
    default:
      console.warn(`Unknown step type: ${(step as any).type}`)
      return null
  }
})
</script>

